import { useEffect, useMemo, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../../components/base/BasicDialog";
import LoaderWrapper from "../../../components/wrapper/LoaderWrapper";
import { Grid, Button, Typography } from "@mui/material";
import EditableTable from "../../../components/table/EditableTable";
import TableService from "../../../services/tableService";

import TextFieldFormControl from "../../../components/field/TextFieldFormControl";

import { LoadingButton } from "@mui/lab";

import { useToasts } from "../../../hooks/useToasts";
import toast from "react-hot-toast";

import { useDiscountProposalFormTableFieldsConfig } from "./DiscountProposalFormTableConfig";
import { useProductsWithPricing, useCreateProposalMutation } from "../../../services/productsService";
import { SnackbarSuccess } from "../../../components/base/SnackbarAlert/SnackbarSuccess";
import { createSearchParams } from "react-router-dom";

export function DiscountProposalForm(props) {
    const { t } = useTranslation();

    const [productDataLocal, setProductDataLocal] = useState();
    const [proposalNote, setProposalNote] = useState();

    const { data: productData } = useProductsWithPricing(createSearchParams({ids: props.productIds, page_size:100}));
    const TABLE_CONFIG = useDiscountProposalFormTableFieldsConfig()

    useEffect(() => {
        if (productData?.results && !productDataLocal) {
            setProductDataLocal(productData?.results);
        }
    }, [productData]);

    const editableData = useMemo(
    () =>
      productDataLocal
        ? TableService.getFieldsConfigForEditableTable(
          TABLE_CONFIG,
          productDataLocal,
          {},
        )
        : [],
    [productDataLocal, TABLE_CONFIG]
  );

    const onChangeTableDataLocal = useCallback(
        (name, value, idx) => {
        setProductDataLocal((prev) => {
            let tempDataLocal = [...prev];
            let product = { ...tempDataLocal[idx] };
            // change proposal_discount base on proposal_discount_pln
            if (name === "proposal_discount_pln" ) {
                if (value && product['listed_price_gross']) {
                    product['proposal_discount'] = (parseFloat(value) * 100  / parseFloat(product['listed_price_gross'])).toFixed(10)
                } else {
                    product['proposal_discount'] = null
                }       
            }
            else{
                product['proposal_discount_pln'] = null
            }
            product[name] = value            
            tempDataLocal[idx] = { ...product };
            return tempDataLocal
        })
        }, [setProductDataLocal]
    );

    const isFormValid = () => (
        productDataLocal && 
        productDataLocal.filter(product=>product.proposal_discount && product.proposal_discount > 0).length > 0
    )

    const prepareDataToSend = (data) => {
        let filteredProductData = data.filter(product=>product.proposal_discount && product.proposal_discount > 0)
        let dataToSend = []
        for (let product of filteredProductData) {
            let productData = {}
            productData['proposal_product'] = product['id']
            productData['proposal_discount'] = product['proposal_discount']
            productData['proposal_note'] = proposalNote
            dataToSend.push(productData)
        }

        return dataToSend
    }

    const { onServerError } = useToasts();

    const { mutate: addProposal, isPending: isAddingProposal } = useCreateProposalMutation({
        onSuccess: () => {
            toast.custom(
                () => <SnackbarSuccess message={t("successfullySend")} />,
                {
                    position: "bottom-right",
                },
            );
            props.onClose()
        },
        onError: (error) => {
            onServerError(error);
        },
    });    

    const onSubmit = () => {
        addProposal({data:prepareDataToSend(productDataLocal)})
    };

    return (
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                rowSpacing={1}
                columnSpacing={2}
            >
                <Grid item xs={12}>
                    <LoaderWrapper showLoader={!productDataLocal}>
                        <EditableTable
                            data={editableData}
                            isLoading={false}
                            showTableLoader={false}
                            readOnly={false}
                            editable={true}
                            showCheckbox={false}
                            showCleanFilterIcon={false}
                            onDataChange={onChangeTableDataLocal}
                            onBlur={() => { }}
                            style={{
                            maxHeight: "50vh",
                            }}
                            tableConfig={TABLE_CONFIG}
                            showContextMenu={false}
                            withParamsComparision={false}
                            showExportToFileButton={false}
                            enableExport={false}
                        />
                    </LoaderWrapper>
                    <Grid item xs={12}>
                        <TextFieldFormControl
                            label={t("products.columns.proposal_note")}
                            value={proposalNote}
                            onChange={(e)=>setProposalNote(e.target.value)}
                            multiline
                            style={{marginTop: "20px"}}
                            rows={3}
                        />
                    </Grid>
                     <Grid item xs={12}>
                        <LoadingButton
                            loading={isAddingProposal}
                            disabled={!isFormValid() || isAddingProposal}
                            variant="contained"
                            color="primary"
                            sx={{ mt: 2 }}
                            onClick={onSubmit}
                            fullWidth
                        >
                            {t("send")}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </Grid>
    );
}